import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import { pageAccounts, updateAccount, createAccount, IAccount, enableAccount, IRolePermission, listRoles } from '../../service/api/account';
import { FormInstance } from 'antd/lib/form/Form';
import { IStore, listStores } from '../../service/api/store';
import './css.less';
const { confirm } = Modal;
const { Option } = Select;

interface IAccountListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const AccountList: React.FC<IAccountListProps> = ({
  visible,
  setVisible,
}) => {
  const [accounts, setAccounts] = useState<IAccount[]>();
  const [roles, setRoles] = useState<IRolePermission[]>();
  const [stores, setStores] = useState<IStore[]>();
  const [accountDetail, setAccountDetail] = useState<IAccount>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();
  const columns = [
    {
      title: '账号名称',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: '角色',
      dataIndex: 'roles',
      key: 'roles',
    },
    {
      title: '数据权限',
      dataIndex: 'stores',
      key: 'stores',
    },
    {
      title: '是否超级管理员',
      dataIndex: 'admin',
      key: 'admin',
      render: (text: any, record: any) => {
        if (record.admin) {
          return '是'
        } else {
          return '否'
        }
      }
    },
    {
      title: '上次登录时间',
      dataIndex: 'lastLoginTime',
      key: 'lastLoginTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    },
    {
      title: '状态',
      dataIndex: 'enable',
      key: 'enable',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <span style={{ color: 'green' }}>使用中</span>
        } else {
          return <span style={{ color: 'grey' }}>已停用</span>
        }
      }
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <Space size="middle">
            <a onClick={() => {
              // console.log("record:" + JSON.stringify(record));
              setAccountDetail(record);
              setVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onEnable(e, record) }}>停用 </a>
          </Space>
        } else {
          return <Space size="middle">
            <a onClick={() => {
              // console.log("record:" + JSON.stringify(record));
              setAccountDetail(record);
              setVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onEnable(e, record) }}>启用 </a>
          </Space>
        }
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (accountDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(accountDetail);
      }, 100);
    }
  }, [accountDetail]);

  const loadData = () => {
    pageAccounts(pageNum, pageSize).then((info: any) => {
      setAccounts(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listRoles().then((info: any) => {
      setRoles(info?.data);
    });
    listStores().then((info: any) => {
      setStores(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (accountDetail) {
      updateAccount({
        ...values,
        id: accountDetail.id
      }).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createAccount(values).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  const onEnable = (e: any, item: IAccount) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: item.enable ? '确定要停用该账号吗？停用后无法被选到' : '确定要启用该账号吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        enableAccount(item.id, !item.enable).then((info: any) => {
          // console.log("info:" + JSON.stringify(info));
          if (info) {
            message.success("操作成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setAccountDetail(undefined);
    setVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };

  // 下拉框值
  const roleOptions = roles?.map((role) =>
    <Option key={role.id} value={role.id}>{role.name}</Option>);
  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  return (
    <Card bordered={false}>
      <Table dataSource={accounts} columns={columns} pagination={false} 
      rowClassName={(record, index) => {
        if (record.enable) {
          return 'accountValid';
        } else {
          return 'accountInvalid';
        }
      }}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
        <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
      <Drawer
        title={accountDetail ? "编辑账号" : "新增账号"}
        visible={visible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="username"
                label="账号名称"
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="password"
                label="账号密码"
                rules={[{ required: true, message: '请输入密码' }]}
              >
                <Input placeholder="请输入密码" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="roleIds"
                label="角色"
                rules={[{ required: true, message: '请选择角色列表' }]}
              >
                <Select placeholder="请选择角色列表" mode="multiple" >
                  {roleOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="storeIds"
                label="数据权限"
                rules={[{ required: true, message: '请选择数据权限' }]}
              >
                <Select placeholder="请选择数据权限" mode="multiple" >
                  {storeOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
};

export default AccountList;
